/**
 * @generated SignedSource<<959328967ae1cedffb3783f3edd2cb70>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RelatedTransactionsTable_report$data = {
  readonly id: string;
  readonly filteredReportResolutions: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly currentValue: any | null;
      readonly initialValue: any | null;
      readonly anomalyTypes: ReadonlyArray<any | null> | null;
      readonly status: string | null;
      readonly resolutionKind: string | null;
    }>;
  } | null;
  readonly " $fragmentType": "RelatedTransactionsTable_report";
};
export type RelatedTransactionsTable_report$key = {
  readonly " $data"?: RelatedTransactionsTable_report$data;
  readonly " $fragmentSpreads": FragmentRefs<"RelatedTransactionsTable_report">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "anomalies"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "transactionData"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./RelatedTransactionsRefetchQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "RelatedTransactionsTable_report",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "anomalies",
              "variableName": "anomalies"
            },
            {
              "kind": "Variable",
              "name": "transactionData",
              "variableName": "transactionData"
            }
          ],
          "kind": "ObjectValue",
          "name": "input"
        }
      ],
      "concreteType": "ReportResolutionsConnection",
      "kind": "LinkedField",
      "name": "filteredReportResolutions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReportResolution",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currentValue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "initialValue",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "anomalyTypes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "resolutionKind",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Report",
  "abstractKey": null
};
})();

(node as any).hash = "4ed600b7855411aacb5d3e2c677ab237";

export default node;
